import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';

const Navigation = () => {
    const { push } = useHistory();

    const sendHome = () => {
        push('/');
    }

    return (
        <header className='nav-container'>
            <div onClick={sendHome} className='logo'>CA</div>
            <nav>
                <NavLink exact to='/' activeClassName='active'>Home</NavLink>
                <NavLink to='/about' activeClassName='active'>About</NavLink>
                <NavLink to='/projects' activeClassName='active'>Projects</NavLink>
                <NavLink to='/resume' activeClassName='active'>Resume</NavLink>
            </nav>
        </header>
    )
}

export default Navigation;